// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(12),
    alias: z.string().min(1).max(128),
    createdAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(12),
    alias: z.string().min(1).max(128),
    createdAt: z.number(),
});
export const UserLoginAliases = Object.freeze({
    table: 'user_login_aliases',
    tableSingular: 'user_login_alias',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        userId: 'user_id',
        alias: 'alias',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'userId',
        'alias',
        'createdAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
